// Shared type and button styles for the nopad homepage sections.
export const display =
  'font-serif text-[clamp(36px,4.5vw,56px)] leading-[1.1] font-semibold tracking-[-0.3px]';

export const h2 =
  'mb-6 font-serif text-2xl leading-[1.2] font-bold tracking-[-0.3px]';

export const h3 =
  'font-serif text-xl leading-[1.2] font-bold tracking-[-0.3px]';

export const body = 'text-base leading-[1.6]';

export const hand = 'font-hand leading-[1.2] tracking-[-0.02em]';

export const button =
  'inline-flex items-center justify-center rounded-[56px] bg-np-pink px-8 py-[18px] font-hand text-[22px] leading-none tracking-[-0.02em] text-np-bg transition hover:-translate-y-px hover:brightness-110';

// The store sells one personalized book; every CTA leads to it.
export const CREATE_BOOK_PATH = '/product/my-kid-story-book';
